<template>
  <div class="step3">
    <!-- 无法推送 -->
    <div class="content cant-push" v-if="!pushed">
      <div class="title">
        <span class="title-icon el-icon-warning-outline"></span>
        <p class="title-text">当前客户账号未绑定微信，服务报告暂时无法推送</p>
      </div>
      <div class="info">
        <p>提示：</p>
        <p>1、建议邀请相关负责人绑定账号微信。</p>
        <p>2、你还可以到报告详情页中复制报告链接，发送给客户。</p>
      </div>
    </div>
    <!-- 已推送 -->
    <div class="content pushed" v-if="pushed">
      <div class="title">
        <span class="title-icon el-icon-success"></span>
        <p class="title-text">服务报告已通过微信公众号推送给对应负责人</p>
      </div>
    </div>
    <!-- 下载中 -->
    <div class="content" v-if="downLoading">
      <div class="title">
        <span class="title-icon el-icon-time"></span>
        <p class="title-text">综合详情报表下载中，请稍后...</p>
        <span v-loading="downLoading" style="display:inline-block;margin-left:10px;"></span>
      </div>
      <div class="info">
        <p>提示：</p>
        <p>1、服务报告为上一步中预览生成的报告，综合详情报表为包含详细信息到的Excel表格。</p>
        <p>2、如需补充简报的建议与说明，请到对应报告的详情页面操作。</p>
        <p>3、如需向客户重复发送报告，可以到报告详情页中复制链接。</p>
        <p>4、在报告详情页中可以重复下载综合详情报表。</p>
      </div>
    </div>
    <!-- 已下载 -->
    <div class="content" v-if="!downLoading">
      <div class="title">
        <span class="title-icon el-icon-success"></span>
        <p class="title-text">综合详情报表下载完成</p>
      </div>
      <div class="info">
        <p>提示：</p>
        <p>1、服务报告为上一步中预览生成的报告，综合详情报表为包含详细信息到的Excel表格。</p>
        <p>2、如需补充简报的建议与说明，请到对应报告的详情页面操作。</p>
        <p>3、如需向客户重复发送报告，可以到报告详情页中复制链接。</p>
        <p>4、在报告详情页中可以重复下载综合详情报表。</p>
      </div>
      <div class="footBtn">
        <el-button size="small" class="confirm" @click="finshed">完成</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import { mapState } from "vuex";
export default {
  name: "stepThird",
  data() {
    return {
      pushed: false,
      downLoading: true
    };
  },
  computed: {
    ...mapState({
      reportQuery: state => state.serviceReport.reportQuery,
      serviceChart: state => state.serviceReport.serviceChart
    })
  },
  created() {
    this.nextStep3();
  },
  methods: {
    finshed() {
      this.$router.push({ path: "/ServiceReport" });
    },
    saveReport() {
      let params = {
        dealerandshop: JSON.parse(this.serviceChart.dealerandshop),
        informreport: JSON.parse(this.serviceChart.informreport),
        intellectual: JSON.parse(this.serviceChart.intellectual),
        everydaylowprice: JSON.parse(this.serviceChart.everydaylowprice),
        ...this.reportQuery
      };
      return new Promise((r, j) => {
        fetch({
          url: "hcm/hcmChannelServiceReport/savechannelServiceReport",
          method: "post",
          headers: { "Content-Type": "application/json" },
          data: JSON.stringify(params)
        })
          .then(res => {
            r(res.data);
          })
          .catch(err => {
            j(err);
          });
      });
    },
    async nextStep3() {
      let res = await this.saveReport();
      this.pushed = res.cas === 0 ? false : res.cas === 1 ? true : null;
      let query = `id=${res.id}&begintime=${this.reportQuery.begintime}&endtime=${this.reportQuery.endtime}&complaintsaccount=${this.reportQuery.complaintsaccount}`;
      let downUrl = `hcm/hcmChannelServiceReport/exportExcelchannelServiceReport?${query}`;
      fetch({
        url: downUrl,
        method: "get",
        params: downUrl,
        noFormat: true,
        responseType: "blob",
        timeout: 60000000 * 1000
      }).then(res => {
        //下载
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", "综合详情报表.xlsx");
        document.body.appendChild(link);
        link.click();
        this.downLoading = false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
$highColor: #108cee;
.step3 {
  margin: 40px auto 0;
  width: 40%;
  min-width: 500px;
  .content {
    margin: 0 0 40px 0;
  }
  .title-icon {
    color: $highColor;
    font-size: 35px;
    vertical-align: middle;
    padding: 0 10px 0 0;
    &.el-icon-warning-outline {
      color: #faad14;
    }
    &.el-icon-success {
      color: #3fb838;
    }
  }
  .title-text {
    font-size: 16px;
    display: inline-block;
  }
  .info {
    padding: 0 0 0 50px;
    color: #999;
    p {
      margin: 0;
      padding: 3px 0;
    }
  }
  .footBtn {
    text-align: center;
  }
}
</style>